// A `/self` failure with one of these statuses means the session is dead, not that the
// server is broken:
//
//   401 - the token is missing, expired or does not verify.
//   403 - the token verifies but no role resolves for the user. `/self` asks for 'viewer',
//         the lowest level in the hierarchy, so the only caller it turns away is one the
//         API cannot place at all.
//   404 - the token points at a user row that is not there any more.
//
// 403 and 404 are what a local database reset leaves behind: the JWT is signed with a
// secret that outlives the reset, so it still verifies, but the user uid inside it was
// dropped with the old rows.
const DEAD_SESSION_STATUSES = [401, 403, 404];

export const isDeadSessionError = (error) => DEAD_SESSION_STATUSES.includes(error?.status);
